import React, {Suspense, useEffect} from 'react';
import './App.css';
import {Route, Routes} from "react-router-dom";
import Layout from "./components/layout/Layout";
import {PersonalCabinet} from "components/pages/personal-cabinet/PersonalCabinet";
import {Test} from "components/pages/test/Test";
import {Groups} from "components/pages/groups/Groups";

import {GroupsContainer} from "components/pages/groups/group-container/GroupsContainer";
import {Lessons} from "components/pages/groups/online-communication/Lessons";
import {StudentsPages} from "components/pages/groups/group-container/students/students-pages/Students-pages";
import {
    HomeWork
} from "components/pages/groups/group-container/students/students-pages/students-tabs/students-home-works/home-work/Home-work";
import {PersonalProfile} from "components/pages/personal-cabinet/personal-profile/personal-profile";
import {BuyCourse} from "components/pages/buy-couse/BuyCourse";
import {CheckOut} from "components/pages/buy-couse/cours-container/check-out/check-out";
import {Account} from "components/pages/buy-couse/cours-container/account/account";
import {PaymentHistory} from "components/pages/payment-history/Payment";
import {Stats} from "components/pages/stats/Stats";
import {SummaryTable} from "components/pages/summary-table/Summary-table";
import {SeparateTest} from "components/pages/test/students-test/separate-test/SeparateTest";
import {TestInnerAnswer} from "components/pages/test/test-inner-answer/TestInnerAnswer";

import {
    StudentResponse
} from "components/pages/groups/online-communication/tabs-content/homework/student-response/StudentResponse";
import {LoginForm} from "ui/login-form/LoginForm";
import {useAppDispatch, useAppSelector} from "common/hook";
import {fetchProfileData} from "entities/Profile/model/fetchProfileDate/fetchProfileDate";
import {getProfileData} from "entities/Profile/model/selectors/getProfileData/getProfileData";
import {RoleType, setRoleType} from "app/user-reduser";
import {RestoreEmailPasswordForm} from "ui/restore-email-password-form/RestoreEmailPasswordForm";
import {RegisterForm} from "ui/register-form/RegisterForm";
import {ConfirmPage} from "ui/confirm-page/ConfirmPage/ConfirmPage";
import {PasswordChangeForm} from "ui/passwordChangeForm.tsx/PasswordChangeForm";
import {SuccessfulRegistration} from 'ui/successful-registration/SuccessfulRegistration';
import {SuccessfulRestorePassword} from "ui/successful-restore-password/SuccessfulPassword";
import {accountUserActions} from "app/accountLoginSlice";
import {AddLesson} from 'components/pages/groups/group-container/lessons/add-lesson/AddLesson';
import {EditLesson} from "components/pages/groups/group-container/lessons/edit-lesson/EditLesson";
import {LessonsDemo} from 'components/pages/groups/online-communication/lessons-demo/LessonsDemo';
import {NotFound} from 'components/pages/not-found/NotFound';
import {TestAdd} from "components/pages/test/test-inner-answer/test-add/TestAdd";
import {TestEdit} from "components/pages/test/test-inner-answer/test-create/TestCreate";
import {ROLE_DEMO_STUDENT, ROLE_HR} from "entities/constants/constants";
import useOneSignalInitialization from "common/hook/useOneSignalInitialization";
import useServiceWorkerMessage from "common/hook/useServiceWorkerMessage";
import {Offline} from "components/pages/offline/Offline";
import useBeforeInstallPrompt from "common/hook/useBeforeInstallPrompt";
import useCheckAuthToken from "common/hook/use-logaut";
import useErrorRedirect from 'common/hook/useErrorRedirect';


function App() {
    const dispatch = useAppDispatch()
    const isLogin = useAppSelector(state => state.accountUser.isLogin);
    const data = useAppSelector(getProfileData)
    const role = data?.role as RoleType;


    useErrorRedirect();

    const {handleInstallClick} = useBeforeInstallPrompt();

    useCheckAuthToken()

    useEffect(() => {
        handleInstallClick();
    }, []);

    useOneSignalInitialization();

    useServiceWorkerMessage();


    useEffect(() => {
        dispatch(accountUserActions.accountUser());
    }, [dispatch])


    useEffect(() => {
        dispatch(fetchProfileData())
    }, [])


    useEffect(() => {
        if (role) {
            dispatch(setRoleType(role));
        }
    }, [dispatch, role]);


    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Routes>
                <Route path="/" element={<Layout/>} errorElement={<NotFound/>}>
                    {role === ROLE_HR ? (
                        <Route index element={isLogin ? <SummaryTable/> : <LoginForm/>}/>
                    ) : (
                        <Route index element={isLogin ? <PersonalCabinet/> : <LoginForm/>}/>
                    )}

                    <Route path="register/" element={<RegisterForm/>}/>
                    <Route path="successful-registration/" element={<SuccessfulRegistration/>}/>
                    <Route path="successful-restore-password/" element={<SuccessfulRestorePassword/>}/>

                    <Route path="personal-profile" element={<PersonalProfile/>}/>

                    <Route path="register/:confirm" element={<ConfirmPage/>}/>
                    <Route path="restore-password/" element={<RestoreEmailPasswordForm/>}/>
                    <Route path="restore-password/:reset" element={<PasswordChangeForm/>}/>

                    <Route path="groups/" element={<Groups/>}/>

                    <Route path="/groups/:groupId" element={<GroupsContainer/>}/>

                    <Route path="groups/:groupId/add-lesson" element={<AddLesson/>}/>

                    <Route path="groups/:groupId/edit-lesson/:lessonsId" element={<EditLesson/>}/>

                    <Route path="/lessons" element={<LessonsDemo/>}/>

                    <Route path="groups/:groupId/lessons/:lessonsId" element={<Lessons/>}/>

                    {role === ROLE_DEMO_STUDENT && (
                        <Route path="/lessons/:lessonsId" element={<Lessons/>}/>
                    )}


                    <Route path="lessons/:lessonsId/:home-work/:studentId" element={<HomeWork/>}/>

                    <Route path="groups/:groupId/:students-pages/:studentId" element={<StudentsPages/>}/>


                    <Route path="groups/:groupId/lessons/:lessonsId/:student-response" element={<StudentResponse/>}/>


                    <Route path="stats" element={<Stats/>}/>
                    <Route path="summary-table" element={<SummaryTable/>}/>
                    <Route path="buy-course" element={<BuyCourse/>}/>
                    <Route path="buy-course/:curseId" element={<CheckOut/>}/>

                    <Route path="buy-course/:curseId/bank-transfer/:trackingId" element={<Account/>}/>

                    <Route path="test" element={<Test/>}/>

                    <Route path="test/:testId" element={<SeparateTest/>}/>


                    <Route path="test/:testId/:view-answer/:userId" element={<TestInnerAnswer/>}/>


                    <Route path="test/:add-test" element={<TestAdd/>}/>

                    <Route path="test/:test-edit/:testId" element={<TestEdit/>}/>


                    <Route path="payment-history" element={<PaymentHistory/>}/>
                    <Route path="offline" element={<Offline/>}/>

                    <Route path="/*" element={<NotFound/>}/>
                    <Route path="/not-found" element={<NotFound/>}/>
                </Route>
            </Routes>
        </Suspense>
    );
}


export default App;

